<template lang="pug">
.m-card-header
  .group
    .date(v-if="source.marketId != 3")
      i.fa-solid.fa-calendar
      |  {{ part1 }} - {{ part2 }}
    template(v-else)
      .icon.active
        ThemeImage(:src="'/images/light/sport/white/' + source.sportsId + '.svg'")
      .icon.inactive
        ThemeImage(:src="'/images/light/sport/blue/' + source.sportsId + '.svg'")
      | {{ source.leagueName }}
  .right(:class="{ 'd-none' : source.marketId == 3 }")
    .date.ml-auto(v-if="racingList.includes(source.sportsId) && source.matchTime") No. {{ part3 }}
  .live(:class="{ 'd-none' : source.marketId != 3 }")
    span.mx-1 LIVE
    .live-dot

</template>

<script>
import config from "@/config";

export default {
  props: {
    source: {
      type: Object
    }
  },
  data() {
    return {
      countDown: 0,
      ticker: null
    };
  },
  computed: {
    currency_code() {
      return this.$store.getters.currencyCode;
    },
    part1() {
      const offset = config.getCurrencyMinuteOffset(this.currency_code);
      const matchTime = this.source.matchTime;
      const mdate = this.$dayjs(matchTime).subtract(offset, 'minute').format('MM/DD');
      const mtime = this.$dayjs(matchTime).subtract(offset, 'minute').format('HH:mm');
      const mt = this.source.marketId;
      const label = this.source.runningTime;
      
      if (mt < 3) {
        return mdate;
      } else {
        return label != null ? (label.trim().length > 0 ? this.getLabel(label) : mtime) : mtime;
      }
    },
    part2() {
      const offset = config.getCurrencyMinuteOffset(this.currency_code);
      const matchTime = this.source.matchTime;
      const mdate = this.$dayjs(matchTime).subtract(offset, 'minute').format('MM/DD');
      const mtime = this.$dayjs(matchTime).subtract(offset, 'minute').format('HH:mm');
      const mt = this.source.marketId;
      const score = this.source.runningScore;
      const label = this.source.runningTime;
      
      if (mt < 3) {
        return mtime;
      } else {
        if (label != null) {
          if (label.trim().length > 0) {
            return score != null ? (score.trim().length > 0 ? score.trim() : mdate) : mdate;
          } else {
            return mdate;
          }
        } else {
          return mdate;
        }
      }
    },
    part3() {
      const mdate = this.$dayjs(this.source.matchTime).format("MMDDhhmm");
      return mdate;
    },
    racingList() {
      return config.racingList;
    }
  },
  methods: {
    getLabel(e) {
      if (/\d/.test(e)) {
        return e.trim();
      }
        
      return this.$tc("m.BT_" + e.trim(), 1);
    },
    getTimerClass(mode) {
      switch(mode) {
        case 45:
          return "m-card-header-wrapper";
        default:
          return "m-card-header";
      }
    }
  }

}
</script>